var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShMedalSolid(props) {
  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 14.337" }, props),
    React.createElement("path", { d: "M6.555 3.661L4.53.435A.947.947 0 003.726 0H.469a.447.447 0 00-.384.705l3.26 4.451a6.178 6.178 0 013.21-1.495zM14.531 0h-3.257a.947.947 0 00-.8.435L8.445 3.661a6.18 6.18 0 013.21 1.495l3.26-4.451A.447.447 0 0014.531 0zM7.499 4.48a5.046 5.046 0 00-5.155 4.929 5.046 5.046 0 005.155 4.928 5.046 5.046 0 005.156-4.928A5.046 5.046 0 007.499 4.48zm2.711 4.4L9.099 9.919l.263 1.462a.334.334 0 01-.488.339l-1.375-.69-1.374.69a.333.333 0 01-.488-.339l.262-1.462L4.79 8.884a.318.318 0 01.186-.549l1.536-.214.687-1.33a.344.344 0 01.6 0l.686 1.331 1.536.214a.318.318 0 01.19.548z" })
  );
}

export default SvgShMedalSolid;